import { Drawer, Grid } from "@material-ui/core";
import { useMemo } from "react";

import { DefaultModalProps } from "./default-modal-props";
import { useStyles } from "./default-modal-styles";

export const DefaultModal = ({minWidth,...props}: DefaultModalProps) => {
  const { ...drawerProps } = useMemo(() => {
    return {
      ...props,
    };
  }, [props]);

  const classes = useStyles();

  return (
    <>
      <Drawer  {...drawerProps}>
        <Grid container style={{ minWidth: minWidth }} className={classes.drawerContainer}>
          {props.children}
        </Grid>
      </Drawer>
    </>
  );
};
